import { useRef, useState } from 'external/react'
import {clsx, styled} from 'external/material'
import useTranslations from 'hooks/translations'
import useStudentContext from 'hooks/student'
import { centerVertically } from 'utils/style'
import DashboardActivityItem from './DashboardActivityItem'
import { DashboardActivityNextButton, DashboardActivityPreviousButton } from './DashboardActivityNavigation'
import GroupFilter from 'components/GroupFilter'

import { dashboardActivityItemHeight} from 'settings'
import EventCategoryFilter from 'components/EventCategoryFilter'

const StyledDashboardActivity = styled('div')(dashboardActivityStyles)

export default function DashboardActivity() {
    const ref = useRef(null) 
    const [scrollLeft, setScroll] = useState(0)
    const {translate} = useTranslations()
    const {groups, recentActivity} = useStudentContext()
    
    function setScrollLeft(x) {
        ref.current.scrollLeft = x
        setScroll(x)
    }

    function handleScroll(e) {
        if (e.target.scrollLeft != scrollLeft)
            setScroll(e.target.scrollLeft)
    }

    return(
        <StyledDashboardActivity>
            <div className='recent-activity-container'>
                <div className='recent-activity-title'>
                    <label>{translate('recent-activities')}</label>
                    <div className={clsx('filter', 'group')}>
                        <GroupFilter preserveQuery />
                    </div>
                    <div className={clsx('filter', 'category')}>
                        <EventCategoryFilter preserveQuery />
                    </div>
                </div>
                <div className='recent-activity-content'>
                    <DashboardActivityPreviousButton className='back' activityElement={ref} scrollLeft={scrollLeft} setScrollLeft={setScrollLeft} />
                    <div ref={ref} className={clsx('activity', {empty: recentActivity.length == 0})} onScroll={handleScroll}>
                        {recentActivity.length == 0 && <div className="no-recent-activity-label">{translate('no-recent-activity-found')}</div>}
                        {recentActivity.map((activity, index) => (<DashboardActivityItem key={index} activity={activity} group={groups.find(g => g.id == activity.clique)} />))}
                    </div>
                    <DashboardActivityNextButton className='forward' activityElement={ref} scrollLeft={scrollLeft} setScrollLeft={setScrollLeft} />
                </div>
            </div>
        </StyledDashboardActivity>
    )
}

function dashboardActivityStyles(){
    return {
        display: 'flex',
        marginTop: 15,
        overflowX: 'hidden',
        flexShrink: 0,
        '& .activity': {
            overflowY: 'hidden'
        },
        '& .recent-activity-container': {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            marginRight: 15,
            marginLeft: 15,
            overflowX: 'hidden'
        },
        '& .activity.empty': {
            ...centerVertically,
            flexGrow: 1,
            textAlign: 'center',
            height: dashboardActivityItemHeight + 38,
            boder: 'solid 1px black'
        },
        '& .recent-activity-title': {
            display: 'flex',
            marginLeft: 2,
            fontSize: '16pt',
            fontWeight: 500,
            height: 60,
            flexShrink:0,
            color: '#434a5d',
            "& > label": {
                ...centerVertically,
                paddingTop: 10,
                flexGrow: 1,
            },
            "& > .filter": {
                ...centerVertically,
                flexShrink: 0,
                '&.group':{'> div': {width: 200}},
                "&.category": {
                    marginLeft: 15,
                    marginRight: 5,
                    '& > div': {width: 150},
                }
            }
        },
        '& .recent-activity-content': {
            display: 'flex',
            overflowX: 'hidden',
            "& > .activity": {
                display: 'flex',
                paddingBottom: 10,
                overflowX: 'auto',
                fontSize: '16pt',
                fontWeight: 500,
                color: '#7b8193',
            }
        },
        "& .navigation-button-container": {
            flexShrink: 0,
            ...centerVertically,
        }
    }
}
